module.exports = __webpack_public_path__ + "3780bca90f45823264693f6c579e75df.svg";